<template>
    <div class="mt-6 p-3 pb-0 mx-auto w-full">
        <slot />
    </div>
</template>